import * as React from 'react';
import { useTranslations } from 'next-intl';

import {
  SquaresFourIcon,
  StorefrontIcon,
  GraduationCapIcon,
  ChatsCircleIcon,
  LayoutIcon,
  type Icon,
} from '@phosphor-icons/react';
import { IconButton, Menu, MenuItem, ListItemText, ListItemIcon } from '@unity/cloud-ui';

import type { MenuItemProps } from '@unity/cloud-ui';

interface MenuItemLinkProps extends MenuItemProps {
  title: string;
  href: string;
  target: string;
  icon: Icon | (() => React.JSX.Element);
}

const MenuItemLink = (props: MenuItemLinkProps) => {
  const { title, icon: Icon, ...rest } = props;
  return (
    <MenuItem component="a" {...rest}>
      <ListItemIcon>
        <Icon />
      </ListItemIcon>
      <ListItemText>{title}</ListItemText>
    </MenuItem>
  );
};

export const QuickAccessMenu = () => {
  const t = useTranslations();
  const [menuAnchorEl, setMenuAnchorEl] = React.useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(menuAnchorEl);

  const handleQuickAccessButtonClick = (e) => {
    setMenuAnchorEl(e.currentTarget);
  };

  const handleRoleClose = () => {
    setMenuAnchorEl(null);
  };

  return (
    <>
      <IconButton
        id="menu-button"
        aria-label={t('quick-access-menu-aria-label:asset-store')}
        aria-controls={isMenuOpen ? 'quick-access-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={isMenuOpen ? 'true' : undefined}
        onClick={handleQuickAccessButtonClick}
      >
        <SquaresFourIcon />
      </IconButton>

      <Menu
        id="quick-access-menu"
        anchorEl={menuAnchorEl}
        open={isMenuOpen}
        onClose={handleRoleClose}
        disableScrollLock
        MenuListProps={{
          'aria-labelledby': 'menu-button',
          disablePadding: false,
          autoFocus: true,
        }}
      >
        <MenuItemLink
          href="https://cloud.unity.com/"
          target="_blank"
          icon={LayoutIcon}
          title={t('quick-access-menu:dashboard')}
        />
        <MenuItemLink
          href="https://assetstore.unity.com"
          target="_blank"
          icon={StorefrontIcon}
          title={t('quick-access-menu:asset-store')}
        />
        <MenuItemLink
          href="https://discussions.unity.com"
          target="_blank"
          icon={ChatsCircleIcon}
          title={t('quick-access-menu:discussions')}
        />
        <MenuItemLink
          href="https://learn.unity.com"
          target="_blank"
          icon={GraduationCapIcon}
          title={t('quick-access-menu:learn')}
        />
      </Menu>
    </>
  );
};
